import React from 'react'
import ReactPaginate from 'react-paginate'
import { CaretLeft, CaretRight } from '../normalizer'

const Pagination = ({totalPages,currentPage, onPageChange})=> {
  return (
    <ReactPaginate
      className='outline-none'
      previousLabel={<CaretLeft/>}
      nextLabel={<CaretRight/>}
      breakLabel='...'
      breakClassName='break-me gl-active-page'
      pageCount={totalPages}
      marginPagesDisplayed={1}
      pageRangeDisplayed={1}
      forcePage={currentPage -1}
      onPageChange={onPageChange}
      containerClassName='gl-pagination justify-start center-xs start-sm list-reset mr-3'
      pageClassName='gl-pagination__page transparent'
      activeClassName='primary-bg gl-active-page text-white'
    />
  )
}

export default Pagination